import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Tooltip from 'root/module/tooltip';
import Modals from 'root/modals';
import View from 'view/base';
import View_Feedback_Reply_Comment from 'view/feedback_viewer/reply_comment';
import View_Feedback_Comment_Editor from 'view/feedback_comment_editor';

export default View.extend({
    className: 'feedback-viewer-thread',

    desc_max_char: 300,

    pending_xhr: [],

    views: {
        comment_editor: {},
        reply_comments: {}
    },

    events: {
        'click'                               : 'select',
        'click .read-more'                    : 'readMore',
        'click .thread-resolve'               : 'resolve',

        'click .thread-edit'                  : 'threadEdit',
        'click .thread-delete'                : 'threadDelete',
        'click .inline-edit-cancel'           : 'threadEditCancel',
        'click .inline-edit-submit'           : 'threadCommentSave',

        'click .thread-attachment-delete'     : 'deleteAttachment',
        'click .attachment-preview-video'     : 'viewVideoAttachment',

        'click .reporter-email-copy'          : 'copyReporterEmail',
        'click .reporter-details-edit'        : 'editReporterDetails',

        'click .view-email-source a'          : 'viewEmailSource'
    },

    dom_handlers: {
        viewEmailSource: function(e) {
            e.preventDefault();
            Modals.openFeedbackEmail(this.feedback.id);
        },

        copyReporterEmail: function(e) {
            Util.copyText(this.feedback.get('email'), () => {
                UI.success('Reporter email copied to clipboard.');
            });
        },

        editReporterDetails: function(e) {
            Modals.editReporterDetails(this.feedback.id);
        },

        // delete attachment from an existing comment
        deleteAttachment: function(e) {
            if (this.model) {
                Modals.deleteFeedbackCommentAttachment(this.model.id);
            } else {
                Modals.deleteFeedbackAttachment(this.feedback.id);
            }
        },

        // preview video attachment that has been submitted
        viewVideoAttachment: function(e) {
            e.preventDefault();

            Modals.previewVideo($(e.currentTarget).attr('href'));
        },

        threadEdit: function(e) {
            this.$el.addClass('editing');

            this.$el.find('.thread-main .actions').hide();
            this.$el.find('.inline-edit-actions').show();

            var comment;

            if (this.model) {
                comment = this.model.escape('comment');
            } else {
                comment = this.feedback.escape('description');
            }

            comment = Util.nl2br(comment);
            comment = Util.parseComment(comment);

            this.$el.find('.thread-main .comment').html(comment);
            this.$el.find('.thread-main .comment').prop('contenteditable', true).focus();
        },

        threadDelete: function(e) {
            e.stopPropagation();
            Tooltip.removeAll();

            if (this.model) {
                Modals.deleteThread(this.model);
            } else {
                Modals.emptyFeedbackDescription(this.feedback);
            }
        },

        threadEditCancel: function(e) {
            this.$el.removeClass('editing');

            this.$el.find('.thread-main .actions').show();
            this.$el.find('.inline-edit-actions').hide();

            this.$el.find('.thread-main .comment').prop('contenteditable', false);
            this.renderMainComment();
        },

        // inline edit submit
        threadCommentSave: function(e) {
            if (this.$el.find('.thread-main .comment').prop('contenteditable') != 'true') {
                return;
            }

            this.$el.removeClass('editing');

            this.$el.find('.thread-main .actions').show();
            this.$el.find('.inline-edit-actions').hide();

            var comment = this.$el.find('.thread-main .comment').prop('contenteditable', false).html();

            var temp_element = $('<div>').html(comment);
            temp_element.find('.at-name').each(function() {
                var user_id = $(this).attr('userid');
                this.outerHTML = '@@:' + user_id + ':' + $(this).text() + '@@';
            });

            comment = temp_element.html();
            comment = Util.sanitizeContenteditable(comment);
            comment = comment.trim();

            if (!comment) {
                this.renderMainComment();
                return;
            }

            if (this.model) {
                if (comment === this.model.get('comment')) {
                    return;
                }

                this.model.set({
                    comment: comment,
                    last_edit_time: Math.ceil((new Date()).getTime() / 1000)
                });

                Cache.app.request({
                    action: 'feedback\\Comment/edit',
                    context: this,
                    data: {
                        id      : this.model.id,
                        comment : comment
                    },
                    success: function() {
                        UI.success('Comment updated');
                    }
                });
            } else {
                if (comment === this.feedback.get('description')) {
                    return;
                }

                this.feedback.set('description', comment);

                Cache.app.request({
                    action: 'feedback/saveDescription',
                    context: this,
                    data: {
                        id          : this.feedback.id,
                        description : comment
                    },
                    success: function() {
                        UI.success('Comment updated');
                    }
                });
            }
        },

        select: function() {
            if (this.model) {
                this.$el.addClass('selected');
                this.dispatcher.trigger('Thread:Select', this.cid, this.model.id);
            } else {
                this.dispatcher.trigger('Thread:Select', this.cid);
            }
        },

        readMore: function(e) {
            e.preventDefault();
            e.stopPropagation();

            var comment = '';

            if (this.model) {
                comment = this.model.escape('comment');
            } else {
                comment = this.feedback.escape('description');
            }

            comment = Util.urlify(comment);
            comment = Util.nl2br(comment);

            this.$el.find('.comment:first').html(comment);
        },

        resolve: function(e) {
            e.stopPropagation();

            if (this.model) {
                this.resolveComment();
            } else {
                this.resolveDesc();
            }
        }
    },

    event_handlers: {
        onThreadSelect: function(view_cid) {
            if (view_cid !== this.cid) {
                this.$el.removeClass('selected');
            }
        },

        onThreadReply: function(view_cid) {
            if (view_cid !== this.cid && !this.views.comment_editor.hasUnsavedChanges()) {
                this.views.comment_editor.hide();
            }
        },

        onPinCommentOpen: function(model_id) {
            if (this.model) {
                if (model_id === this.model.id) {
                    this.$el.addClass('selected');
                    this.scrollTo();

                    if ((this.model.get('video_time') || this.model.get('screen_number') || this.model.get('video_number')) && !this.model.get('comment') && this.model.get('user_id') === Cache.real_user_id && _.size(this.views.reply_comments) === 0) {
                        this.$el.find('.reply').click();
                    }
                } else {
                    this.$el.removeClass('selected');
                }
            } else {
                this.$el.removeClass('selected');
                return;
            }
        },

        onPinCommentClose: function(model_id) {
            if (this.model && model_id === this.model.id) {
                this.$el.removeClass('selected');
            }
        },

        onCommentAdd: function(model) {
            var do_add = false;

            if (model.get('feedback_id') === this.feedback.id) {
                if (this.model) {
                    if (model.get('reply_comment_id') === this.model.id) {
                        do_add = true;
                    }
                } else {
                    if (!model.get('reply_comment_id') && !model.get('video_time') && !model.get('screen_number') && !model.get('video_number')) {
                        do_add = true;
                    }
                }
            }

            if (do_add) {
                this.newReplyCommentView(model);
                this.renderReplyComment(this.views.reply_comments['_' + model.id]);
            }
        },

        onCommentDelete: function(model) {
            var view = this.views.reply_comments['_' + model.id];

            if (view) {
                view.remove();
            }
        },

        onCommentChange: function(model) {
            this.renderMainComment();
        },

        onReplyCancel: function() {
            this.views.comment_editor.hide();
        },

        onReplySubmit: function(editor_data) {
            var _doPost = () => {
                this.views.comment_editor.disable();

                if (this.isVideoNote() || this.isDesignNote() || this.isVideoCaptureNote()) {
                    // do not submit as attachment
                    // upload to presigned url later
                    if (editor_data.video_capture.presigned_url) {
                        editor_data.attachment_info = {};
                    }

                    var _postFinish = function() {
                        this.views.comment_editor.enable();
                        this.views.comment_editor.clearMessage();

                        UI.success('Note added');
                    }.bind(this);

                    if (editor_data.video_capture.presigned_url) {
                        this.postVideoRecording(editor_data, function() {
                            if (editor_data.comment) {
                                this.postNote(editor_data, function(data) {
                                    this.model.set(_.extend(data, {
                                        attachment: editor_data.video_capture.object_url
                                    }));

                                    _postFinish();
                                }.bind(this));
                            } else {
                                this.model.set({
                                    attachment: editor_data.video_capture.object_url
                                });
                                _postFinish();
                            }
                        }.bind(this));
                    } else {
                        this.postNote(editor_data, function(data) {
                            this.model.set(data);
                            _postFinish();
                        }.bind(this));
                    }
                } else {
                    this.postReply(editor_data);
                }
            };

            if (Cache.real_user_id) {
                _doPost();
            } else {
                var anon_user = Cache.getGuestUser();

                if (anon_user.email && anon_user.name) {
                    _doPost();
                } else {
                    Modals.viewerGuest(_doPost);
                }
            }
        }
    },

    postVideoRecording: function(editor_data, on_success) {
        var xhr = $.ajax(editor_data.video_capture.presigned_url, {
            type: 'PUT',
            data: editor_data.video_capture.blob,
            crossDomain: true,
            processData: false,
            complete: () => {
                var index = this.pending_xhr.indexOf(xhr);

                if (index !== -1) {
                    this.pending_xhr.splice(index, 1);
                }
            },
            success: () => {
                // update attachment in database
                var xhr = Cache.app.request({
                    action: 'feedback\\Comment/setAttachment',
                    data: {
                        id        : this.model.id,
                        attachment: editor_data.video_capture.object_url
                    },
                    complete: () => {
                        var index = this.pending_xhr.indexOf(xhr);

                        if (index !== -1) {
                            this.pending_xhr.splice(index, 1);
                        }
                    },
                    success: () => {
                        on_success();
                    }
                });

                this.pending_xhr.push(xhr);
            }
        });

        this.pending_xhr.push(xhr);
    },

    postNote: function(editor_data, on_success) {
        var xhr = Cache.app.request({
            action: 'feedback\\Comment/addNote',
            data: {
                feedback_id             : this.feedback.id,
                id                      : this.model.id,
                is_public               : editor_data.is_public,
                comment                 : editor_data.comment,
                notify                  : editor_data.notify_list,
                attachment_file_name    : editor_data.attachment.file_name,
                attachment_file_content : editor_data.attachment.file_content
            },
            complete: () => {
                var index = this.pending_xhr.indexOf(xhr);

                if (index !== -1) {
                    this.pending_xhr.splice(index, 1);
                }
            },
            error: () => {
                if (this.views.comment_editor.enable) {
                    this.views.comment_editor.enable();
                }
            },
            success: (data) => {
                on_success(data);
            }
        });

        this.pending_xhr.push(xhr);
    },

    postReply: function(editor_data) {
        var xhr = Cache.app.request({
            action: 'feedback\\Comment/add',
            data: {
                id                      : this.feedback.id,
                reply_comment_id        : this.model ? this.model.id : undefined,
                is_public               : editor_data.is_public,
                comment                 : editor_data.comment,
                notify                  : editor_data.notify_list,
                attachment_file_name    : editor_data.attachment.file_name,
                attachment_file_content : editor_data.attachment.file_content
            },
            complete: () => {
                var index = this.pending_xhr.indexOf(xhr);

                if (index !== -1) {
                    this.pending_xhr.splice(index, 1);
                }

                if (this.views.comment_editor.enable) {
                    this.views.comment_editor.enable();
                }
            },
            success: (data) => {
                this.views.comment_editor.clearMessage();

                Cache.feedback_comment.add(data);
                UI.success('Comment added');
            }
        });

        this.pending_xhr.push(xhr);
    },

    initialize: function(options) {
        this.feedback   = options.feedback;
        this.dispatcher = options.dispatcher;
        this.inbox_view = !!options.inbox;
        this.is_viewer  = !!options.is_viewer;

        this.views = {
            comment_editor: {},
            reply_comments: {}
        };

        this.desc_max_char = this.inbox_view ? 600 : 300;

        // create views
        if (this.model) {
            // pinned comment or bookmark
            Cache.feedback_comment.where({feedback_id: this.feedback.id, reply_comment_id: this.model.id}).forEach((model) => {
                this.newReplyCommentView(model);
            });
        } else {
            // description
            Cache.feedback_comment.where({feedback_id: this.feedback.id, reply_comment_id: 0, screen_x: 0, video_time: 0}).forEach((model) => {
                this.newReplyCommentView(model);
            });
        }

        this.views.comment_editor = new View_Feedback_Comment_Editor({
            model        : this.model,
            feedback     : this.feedback,
            inbox_view   : this.inbox_view,
            is_viewer    : this.is_viewer,
        });

        // bind events

        if (this.model) {
            this.listenTo(this.model, 'change:comment',    this.event_handlers.onCommentChange);
            this.listenTo(this.model, 'change:attachment', this.event_handlers.onCommentChange);
        } else {
            this.listenTo(this.feedback, 'change:description', this.event_handlers.onCommentChange);
            this.listenTo(this.feedback, 'change:attachment',  this.event_handlers.onCommentChange);
        }

        this.listenTo(this.feedback, 'change:name',   this.event_handlers.onCommentChange);
        this.listenTo(this.feedback, 'change:email',  this.event_handlers.onCommentChange);

        this.listenTo(Cache.feedback_comment, 'add',    this.event_handlers.onCommentAdd);
        this.listenTo(Cache.feedback_comment, 'remove', this.event_handlers.onCommentDelete);

        this.views.comment_editor.on('submit', this.event_handlers.onReplySubmit.bind(this));
        this.views.comment_editor.on('cancel', this.event_handlers.onReplyCancel.bind(this));

        var _thread_select     = this.event_handlers.onThreadSelect.bind(this);
        var _thread_replyopen  = this.event_handlers.onThreadReply.bind(this);
        var _pin_comment_open  = this.event_handlers.onPinCommentOpen.bind(this);
        var _pin_comment_close = this.event_handlers.onPinCommentClose.bind(this);

        this.dispatcher.on('Thread:Select',           _thread_select);
        this.dispatcher.on('Thread:ReplyOpen',        _thread_replyopen);
        this.dispatcher.on('Sidebar::View::Comments', _pin_comment_open);
        this.dispatcher.on('Pin_Comment:Open',        _pin_comment_open);
        this.dispatcher.on('Pin_Comment:Close',       _pin_comment_close);

        this.on('remove', function() {
            this.dispatcher.off('Thread:Select',           _thread_select);
            this.dispatcher.off('Thread:ReplyOpen',        _thread_replyopen);
            this.dispatcher.off('Sidebar::View::Comments', _pin_comment_open);
            this.dispatcher.off('Pin_Comment:Open',        _pin_comment_open);
            this.dispatcher.off('Pin_Comment:Close',       _pin_comment_close);

            if (this.pending_xhr.length) {
                this.pending_xhr.forEach((xhr) => {
                    xhr.abort();
                });

                this.pending_xhr = [];
            }
        });

        // hack
        if (this.model) {
            this.hide();

            if (this.model.id === '_temp') {
                this.$el.addClass('temp');
            }
        }
    },

    select: function(open_reply) {
        this.$el.click();

        if (open_reply) {
            this.$el.find('.reply').click();
        }

        this.scrollTo(open_reply);
    },

    renderVideoCapture: function(video_capture_blob, presigned_url, object_url) {
        var reader = new FileReader();
        reader.readAsDataURL(video_capture_blob);
        reader.onloadend = function() {
            this.views.comment_editor.video_capture_info = {
                blob          : video_capture_blob,
                presigned_url : presigned_url,
                object_url    : object_url
            };
            this.views.comment_editor.renderAttachment('video_recording.webm', 'video/webm', reader.result);
        }.bind(this);
    },

    scrollTo: function(scroll_to_reply) {
        if (this.model && this.model.id === '_temp') {
            return;
        }

        if (scroll_to_reply) {
            this.$el.get(0).scrollIntoView({
                block: 'end',
                inline: 'start'
            });
        } else {
            this.$el.get(0).scrollIntoView({
                block: 'nearest'
            });
        }
    },

    resolveComment: function() {
        this.model.set('is_resolved', !this.model.get('is_resolved'));

        if (this.model.get('is_resolved')) {
            this.$el.addClass('resolved');
            this.$el.find('.thread-resolve').data('title', 'Reopen');

            UI.success('Comment resolved');
        } else {
            this.$el.removeClass('resolved');
            this.$el.find('.thread-resolve').data('title', 'Resolve');

            UI.success('Comment reopened');
        }

        Tooltip.removeAll();

        Cache.app.request({
            action: 'feedback\\Comment/resolve',
            data: {
                id: this.model.get('id')
            }
        });
    },

    resolveDesc: function() {
        this.feedback.set('is_desc_resolved', !this.feedback.get('is_desc_resolved'));

        if (this.feedback.get('is_desc_resolved')) {
            this.$el.addClass('resolved');
            this.$el.find('.thread-resolve').data('title', 'Reopen');

            UI.success('Comment resolved');
        } else {
            this.$el.removeClass('resolved');
            this.$el.find('.thread-resolve').data('title', 'Resolve');

            UI.success('Comment reopened');
        }

        Tooltip.removeAll();

        Cache.app.request({
            action: 'feedback/resolveDesc',
            data: {
                id: this.feedback.id
            }
        });
    },

    newReplyCommentView: function(model) {
        this.views.reply_comments['_' + model.id] = new View_Feedback_Reply_Comment({
            model        : model,
            feedback     : this.feedback,
            mention_list : this.mention_list,
            notify_list  : this.notify_list,
            inbox        : this.inbox_view,
            is_viewer    : this.is_viewer,
        });
    },

    renderReplyComment: function(view) {
        view.render().$el.appendTo(this.$el.find('.region-comments-reply'));
    },

    getDisplayTime: function() {
        var seconds = Math.round(this.model.get('video_time'));

        var hour = Math.floor(seconds / 3600);
        var min  = Math.floor((seconds - hour * 3600) / 60);
        var sec  = seconds - hour * 3600 - min * 60;

        if (min < 10) {
            min = '0' + min;
        }

        if (sec < 10) {
            sec = '0' + sec;
        }

        return (hour ? hour + ':' : '') + min + ':' + sec;
    },

    getFeedbackReporterName: function(hide_email_tooltip) {
        var name = '';

        // when a pin comment / feedback desc is added via feedback widget
        if (this.feedback.get('name')) {
            if (Cache.real_user_id && this.feedback.get('email')) {
                name += '<span class="tooltip" data-title="' + (hide_email_tooltip ? '' : this.feedback.escape('email')) + '">' + this.feedback.escape('name') + '</span>';
            } else {
                name += '<span>' + this.feedback.escape('name') + '</span>';
            }
        } else if (this.feedback.get('email')) {
            if (Cache.real_user_id) {
                name += '<span>' + this.feedback.escape('email') + '</span>';
            }
        } else {
            name += '<span>Anonymous</span>';
        }

        return name;
    },

    getThreadReporterName: function(hide_email_tooltip) {
        var name = '';

        if (this.model && this.model.get('anon_name')) {
            // when a pin comment is added by anon
            if (Cache.real_user_id) {
                name += '<span class="tooltip" data-title="' + (hide_email_tooltip ? '' : this.model.escape('anon_email')) + '">' + this.model.escape('anon_name') + '</span>';
            } else {
                name += '<span>' + this.model.escape('anon_name') + '</span>';
            }
        } else if (this.model && this.model.get('user_id')) {
            var user = Cache.user.get(this.model.get('user_id'));

            if (user) {
                if (Cache.real_user_id) {
                    name += '<span class="tooltip" data-title="' + (hide_email_tooltip ? '' : user.escape('email')) + '">' + user.escape('name') + '</span>';
                } else {
                    name += '<span>' + user.escape('name') + '</span>';
                }
            } else {
                name += '<span class="strike">Deleted user</span>';
            }
        } else {
            name = this.getFeedbackReporterName(hide_email_tooltip);
        }

        return name;
    },

    getFeedbackDesc: function() {
        var content = '';

        var is_empty = this.feedback.get('description') === '';

        content += '<div class="thread-title">' +
                        '<div class="user-img-32" style="background-image:url(\'' + this.feedback.getReporterAvatar(24) + '\');"></div>' +
                        '<div class="margin-left-8 margin-right-16' + (this.feedback.get('email') ? '' : ' flex-start') + '">' +
                            '<div class="font-weight-medium">' + this.getThreadReporterName(true) + '</div>' +
                            '<div class="text-info">' + this.feedback.escape('email') +
                                (this.feedback.get('email') ?
                                    '<span class="reporter-email-copy"><i class="fa-solid fa-copy"></i></span>' : '') +
                                (Cache.app.isAdmin() || Cache.app.isCollaborator() ?
                                '<span class="reporter-details-edit tooltip" data-title="Edit Reporter Details"><i class="fa-solid fa-pen-to-square"></i></span>' : '') +
                            '</div>' +
                        '</div>' +
                        '<div class="thread-time tooltip" data-title="' + Util.moment(this.feedback.get('time'), 'DD MMM YYYY hh:mm a', undefined, false) + '">' + Util.moment(this.feedback.get('time')) + '</div>' +
                    '</div>' +

                    '<div class="thread-content">' +
                       '<div class="comment">';

        if (is_empty) {
            content += '<span class="italic text-info">' + (this.model ? 'No comment left' : 'No feedback description left') + '</span>';
        } else if (this.inbox_view || this.feedback.get('description').length <= this.desc_max_char) {
            content += Util.urlify(Util.nl2br(this.feedback.escape('description')));
        } else {
            content += Util.urlify(Util.nl2br(Util.htmlEntities(Util.trim(this.feedback.get('description'), this.desc_max_char, '')))) +
                      ' <span style="white-space:nowrap;">... <a href="#" class="read-more info no-underline hover-underline"> See more</a></span>';
        }

        content +=     '</div>';

        if (this.canEditComment()) {
            content += '<div class="inline-edit-actions">' +
                            '<button class="inline-edit-cancel text tiny">Cancel</button>' +
                            '<button class="inline-edit-submit primary tiny">Save</button>' +
                        '</div>';
        }

        if (this.feedback.get('load_type') === 'email' && Cache.real_user_id && !Cache.app.isClient()) {
            content += '<div class="view-email-source"><a href="#" class="primary font-weight-medium"><i class="fa-solid fa-envelope"></i> View Email</a></div>';
        }

        content += '</div>';

        content += this.getAttachmentHtml();

        return content;
    },

    getPinComment: function() {
        var content = '';

        content += '<div class="thread-title">' +
                        '<div class="pin-num">' + this.model.get('screen_number') + '</div>' +
                        '<span>' + this.getThreadReporterName() + '</span>' +
                        '<div class="thread-time tooltip" data-title="' + Util.moment(this.model.get('time'), 'DD MMM YYYY hh:mm a', undefined, false) + '">' + Util.moment(this.model.get('time')) + '</div>' +
                        (Cache.real_user_id && !Cache.app.isClient() && !this.model.get('is_public') ?
                        '<i class="comment-type-icon margin-left-4 text-warning fad fa-fw fa-lock-alt tooltip" data-title="Team only"></i>' : '') +
                    '</div>';

        content += '<div class="thread-content">';
        content +=     '<div class="comment">';

        if (this.inbox_view || this.model.get('comment').length <= this.desc_max_char) {
            content += Util.parseComment(Util.urlify(Util.nl2br(this.model.escape('comment'))));
        } else {
            content += Util.parseComment(Util.urlify(Util.nl2br(Util.htmlEntities(Util.trim(this.model.get('comment'), this.desc_max_char, '')))));
            content += ' <span style="white-space:nowrap;">... <a href="#" class="read-more info no-underline hover-underline"> See more</a></span>';
        }

        content +=     '</div>';

        if (this.model.get('last_edit_time')) {
            content += '<div class="edited">' +
                            '<span class="tooltip" data-title="' + Util.moment(this.model.get('last_edit_time')) + '">(edited)</span>' +
                        '</div>';
        }

        if (this.canEditComment()) {
            content += '<div class="inline-edit-actions">' +
                            '<button class="inline-edit-cancel text tiny">Cancel</button>' +
                            '<button class="inline-edit-submit primary tiny">Save</button>' +
                        '</div>';
        }

        content += this.getAttachmentHtml();
        content += '</div>';

        return content;
    },

    // video capture attachment in design feedback
    getVideoCaptureComment: function() {
        var content = '';

        content += this.getUserAvatarHtml();

        content += '<div class="thread-content">';
        content +=     '<div class="comment">';

        if (this.inbox_view || this.model.get('comment').length <= this.desc_max_char) {
            content += Util.parseComment(Util.urlify(Util.nl2br(this.model.escape('comment'))));
        } else {
            content += Util.parseComment(Util.urlify(Util.nl2br(Util.htmlEntities(Util.trim(this.model.get('comment'), this.desc_max_char, '')))));
            content += ' <span style="white-space:nowrap;">... <a href="#" class="read-more info no-underline hover-underline"> See more</a></span>';
        }

        content +=     '</div>';

        if (this.canEditComment()) {
            content += '<div class="inline-edit-actions">' +
                            '<button class="inline-edit-cancel text tiny">Cancel</button>' +
                            '<button class="inline-edit-submit primary tiny">Save</button>' +
                        '</div>';
        }

        content += this.getAttachmentHtml();
        content += '</div>';

        return content;
    },

    // video feedback
    getVideoComment: function() {
        var is_empty = this.model.get('comment') === '';

        var content = '';

        content += this.getUserAvatarHtml();

        content += '<div class="thread-content">';
        content +=     '<div class="comment">';

        if (is_empty) {
            content += '<span class="italic info">Empty bookmark</span>';
        } else if (this.model.get('comment').length <= this.desc_max_char) {
            content += Util.parseComment(Util.urlify(Util.nl2br(this.model.escape('comment'))));
        } else {
            content += Util.parseComment(Util.urlify(Util.nl2br(Util.htmlEntities(Util.trim(this.model.get('comment'), this.desc_max_char, '')))));
            content += ' <span style="white-space:nowrap;">... <a href="#" class="read-more info no-underline hover-underline"> See more</a></span>';
        }

        content +=     '</div>';

        if (this.canEditComment()) {
            content += '<div class="inline-edit-actions">' +
                            '<button class="inline-edit-cancel text tiny">Cancel</button>' +
                            '<button class="inline-edit-submit primary tiny">Save</button>' +
                        '</div>';
        }

        content += this.getAttachmentHtml();
        content += '</div>';

        return content;
    },

    getUserAvatarHtml: function() {
        var content = '';

        content += '<div class="thread-title">';

        content += '<div class="user-img-24 tooltip" data-title="' + this.feedback.escape('email') + '" style="background-image:url(\'' + this.feedback.getReporterAvatar(24) + '\');"></div>';

        content += '<span class="font-weight-medium">' + this.getFeedbackReporterName(true) + '</span>';

        if (this.model.get('video_time')) {
            content += '<div class="thread-time"><i class="fas fa-play-circle"></i> ' + this.getDisplayTime() + '</div>';
        } else {
            content += '<div class="thread-time">' + Util.moment(this.model.get('time')) + '</div>';
        }

        if (Cache.real_user_id && !Cache.app.isClient()) {
            if (!this.model.get('is_public')) {
                content += '<i class="comment-type-icon margin-left-4 text-warning fad fa-fw fa-lock-alt tooltip" data-title="Team only"></i> ';
            }
        }

        content += '</div>';

        return content;
    },

    getAttachmentHtml: function() {
        var content = '';

        if (this.model) {
            if (this.model.get('attachment')) {
                content += '<div class="attachment-container">';
                content += '<div class="attachment">';

                if (this.model.get('attachment_uploading')) {
                    content +=  '<i class="far fa-fw fa-spinner fa-spin"></i> <span>' + Util.htmlEntities(Util.baseName(this.model.get('attachment'))) + '</span>';
                } else {
                    var attachment_name = Util.baseName(this.model.get('attachment'));

                    content += Util.getFileIcon(this.model.get('attachment'), false) +
                                '<a href="' + Util.safeUrl(this.model.get('attachment')) + '" target="_blank">' +
                                    (attachment_name === 'capture.webm' ? 'video recording' : Util.htmlEntities(attachment_name)) +
                                '</a>';

                    if (this.canEditComment()) {
                        content += '<button type="button" class="thread-attachment-delete attachment-delete tooltip" data-title="Remove attachment"><i class="fa-solid fa-trash"></i></button>';
                    }
                }

                content += '</div>';

                if (!this.model.get('attachment_uploading')) {
                    content += Util.isImage(this.model.get('attachment')) ? '<a class="attachment-preview" href="' + this.model.escape('attachment') + '" target="_blank"><img src="' + this.model.escape('attachment') + '"></a>' : '';
                    content += Util.isVideo(this.model.get('attachment')) ? '<a class="attachment-preview attachment-preview-video" href="' + this.model.escape('attachment') + '"><video src="' + this.model.escape('attachment') + '" muted></video></a>' : '';
                }

                content += '</div>';
            }
        } else {
            if (this.feedback.get('attachment')) {
                content += '<div class="attachment-container">';
                content += '<div class="attachment">';
                content += Util.getFileIcon(this.feedback.get('attachment'), false) + '<a href="' + Util.safeUrl(this.feedback.get('attachment')) + '" target="_blank">' + Util.htmlEntities(Util.baseName(this.feedback.get('attachment'))) + '</a>';

                if (this.canEditComment()) {
                    content += '<button type="button" class="thread-attachment-delete attachment-delete tooltip" data-title="Remove attachment"><i class="fa-solid fa-trash"></i></button>';
                }

                content += '</div>';
                content += Util.isImage(this.feedback.get('attachment')) ? '<a class="attachment-preview" href="' + this.feedback.get('attachment') + '" target="_blank"><img src="' + this.feedback.get('attachment') + '"></a>' : '';
                content += Util.isVideo(this.feedback.get('attachment')) ? '<a class="attachment-preview" href="' + this.feedback.get('attachment') + '" target="_blank"><video src="' + this.feedback.get('attachment') + '" muted></video></a>' : '';
                content += '</div>';
            }
        }

        return content;
    },

    canComment: function() {
        var can_comment = false;

        if (this.feedback.get('allow_public_comment') || Cache.real_user_id) {
            can_comment = true;
        }

        return can_comment;
    },

    // is the first video bookmark note?
    isVideoNote: function() {
        if (this.model && this.model.get('video_time') && !this.model.get('comment') && !this.model.get('attachment') && this.model.get('user_id') === Cache.real_user_id && _.size(this.views.reply_comments) === 0) {
            return true;
        } else {
            return false;
        }
    },

    // is the first video capture note?
    isVideoCaptureNote: function() {
        if (this.model && this.model.get('video_number') && !this.model.get('comment') && !this.model.get('attachment') && this.model.get('user_id') === Cache.real_user_id && _.size(this.views.reply_comments) === 0) {
            return true;
        } else {
            return false;
        }
    },

    // is the first design feedback note?
    isDesignNote: function() {
        if (this.model && this.model.get('screen_number') && !this.model.get('comment') && !this.model.get('attachment') && this.model.get('user_id') === Cache.real_user_id && _.size(this.views.reply_comments) === 0) {
            return true;
        } else {
            return false;
        }
    },

    openReply: function() {
        this.views.comment_editor.show();
    },

    show: function() {
        this.$el.css('display', '');
    },

    hide: function() {
        this.$el.css('display', 'none');
    },

    focusEditor: function() {
        this.views.comment_editor.focus();
    },

    canEditComment: function() {
        var can_edit = false;

        if (Cache.real_user_id) {
            if (this.model) {
                can_edit = Cache.real_user_id === this.model.get('user_id') || Cache.app.isAdmin();
            } else {
                can_edit = Cache.app.isAdmin();
            }
        }

        return can_edit;
    },

    renderMainComment: function() {
        var content = '';

        if (this.model) {
            if (this.model.get('screen_number')) {
                content += this.getPinComment();
            } else if (this.model.get('video_time')) {
                content += this.getVideoComment();
            } else if (this.model.get('video_number')) {
                content += this.getVideoCaptureComment();
            }
        } else {
            content += this.getFeedbackDesc();
        }

        this.$el.find('.thread-body').html(content);
    },

    render: function() {
        var content = '';

        var can_comment = this.canComment();
        var is_resolved = false;

        if (this.model) {
            is_resolved = this.model.get('is_resolved');
        } else {
            is_resolved = this.feedback.get('is_desc_resolved');
        }

        if (is_resolved) {
            this.$el.addClass('resolved');
        }

        content += '<div class="thread-main">';

        if (Cache.real_user_id) {
            content += '<div class="actions">';

            if (this.canEditComment()) {
                content += '<button type="button" class="thread-edit"><i class="fa-solid fa-pen tooltip" data-title="Edit"></i></button>';
                content += '<button type="button" class="thread-delete"><i class="fa-solid fa-trash tooltip" data-title="Delete"></i></button>';
            }

            if (is_resolved) {
                content += '<button type="button" class="thread-resolve tooltip" data-title="Reopen"><i class="fas fa-check-circle"></i></button>';
            } else {
                content += '<button type="button" class="thread-resolve tooltip" data-title="Resolve"><i class="fas fa-check-circle"></i></button>';
            }

            content += '</div>';
        }

        content +=     '<div class="thread-body"></div>';
        content += '</div>';

        content += '<div class="region-comments-reply"></div>';

        if (can_comment) {
            content += '<div class="thread-new">' +
                           (Cache.real_user_id ?
                           '<img class="user-24 user-current" src="' + Util.htmlEntities(Cache.getRealUser().getAvatar(24)) + '">' :
                           '<img class="user-24 user-current" src="' + Util.gravatar(Cache.getGuestUser().email, 24, Cache.getGuestUser().name) + '">') +
                       '</div>';
        }

        this.$el.html(content);

        if (can_comment) {
            this.views.comment_editor.render().$el.appendTo(this.$el.find('.thread-new'));
        }

        this.renderMainComment();

        _.each(this.views.reply_comments, (view) => {
            this.renderReplyComment(view);
        });

        return this;
    }
});